<template>
  <div class="container">
    <ul class="section">
      <li
        v-for="(item, index) in shoes"
        :key="index"
        :class="{deactive: item === null}"
      >{{ index + offset }}</li>
    </ul>
    <ul class="total">
      <li v-for="(item, index) in shoes" :key="index" :class="{deactive: item === null}">
        <CounterComponent :count="Number(item)"/>
      </li>
    </ul>
  </div>
</template>

<script>
import _ from "lodash";
import CounterComponent from "@/components/Counter.vue";

export default {
  name: "RaceHeaderComponent",
  components: {
    CounterComponent
  },
  computed: {
    offset() {
      return this.$store.state.section > 5 ? 6 : 1;
    },
    shoes() {
      let temp = _.values(this.$store.state.shoes);
      return this.$store.state.section > 5 ? temp.slice(5) : temp.slice(0, 5);
    }
  }
};
</script>

<style scoped lang="scss">
$space: 0.78em;
$width: vw(80);
.container {
  position: relative;
  padding: vw(40) vw(10) vw(10) vw(60);
  background-color: $bg-color;
  line-height: 1;
}
.section {
  display: flex;
  justify-content: space-around;
  font-size: vw(46);
  height: $space;
  margin-bottom: vw(20);
  > li {
    width: $width;
    &.deactive {
      opacity: 0.4;
    }
  }
}
.total {
  display: flex;
  justify-content: space-around;
  font-size: vw(36);
  height: $space;
  margin-bottom: vw(10);
  > li {
    width: $width;
    // background-color: aqua;
    &::after {
      content: "";
      display: inline-block;
      width: vw(32);
      height: 100%;
      background-image: url("../assets/img/slash23.svg");
      background-repeat: no-repeat;
      background-position: bottom right;
      background-size: contain;
    }
    &.deactive {
      opacity: 0.4;
    }
  }
}
</style>
